import { render, staticRenderFns } from "./ImageAd.vue?vue&type=template&id=1f748ca0&scoped=true"
import script from "./ImageAd.vue?vue&type=script&lang=js"
export * from "./ImageAd.vue?vue&type=script&lang=js"
import style0 from "./ImageAd.vue?vue&type=style&index=0&id=1f748ca0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f748ca0",
  null
  
)

export default component.exports